<!--page starts-->
<section class="page-wrapper">
    <div class="confirmation-section margin-top-152 cf"> 
        <div class="container">
            <div class="confirmation-detail cf">
                <div class="titel-box">
					<h2 class="titel-name">Order Confirmation</h2>
				</div>
            </div>
        </div>
    </div>
    <div class="confirmation-success-section" style="background-image: url(assets/images/logiin-bg-img.png);">
        <div class="container">
            <div class="confirmation-success-detail">
                <div class="confirmation-success-detail-inner">
                    <h2>Great!</h2>
                    <p>Your order has been placed successfully! we will email <br> you order details on your registered email address.</p>
                    <div class="confirmation-success-btn">
                        <a routerLink="/home">Go to Home</a>
                    </div>
                </div>

            </div>
        </div>
        <div class="confirmation-success-overlay"></div>
    </div>
 </section><!-- page ends-->